"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const selectbutton_1 = require("primereact/selectbutton");
const react_1 = require("react");
const SelectButton = (props) => {
    const handleChange = (0, react_1.useCallback)((event) => {
        if (props.onChange) {
            props.onChange(event.value);
        }
    }, [props.onChange]);
    return ((0, jsx_runtime_1.jsx)(selectbutton_1.SelectButton, { allowEmpty: props.isEmptyAllowed, options: props.options, value: props.value, onChange: handleChange, className: props.className, width: props.width, pt: props.pt }));
};
exports.SelectButton = SelectButton;
exports.SelectButton.defaultProps = {
    isEmptyAllowed: false,
};
